import React from 'react';
import { Modal, Spin } from 'antd';
import WorkExperiences from '@/components/common/WorkExperiences';
import './style.less';

// 交通信息
const TransportChangeHistoryModal = ({ type, open, guestInfo, changeRecords, loading = false, onCancel }) => {
    const titleText = type === 'arrival' ? '来程变更变更记录' : '返程变更变更记录';

    // 格式化交通信息为文本
    const formatTransport = transport => {
        const parts = [];

        // 交通类型
        if (transport.type) {
            parts.push(transport.type);
        }

        // 航班/车次号
        if (transport.number) {
            parts.push(transport.number);
        }

        // 座位类型
        if (transport.cabin) {
            parts.push(transport.cabin);
        }

        // 出发地→到达地
        if (transport.from || transport.to) {
            const place = `${transport.from || ''}→${transport.to || ''}`.replace(/^→|→$/g, '');
            if (place) {
                parts.push(place);
            }
        }

        // 日期和时间
        const timeParts = [];
        if (transport.date) {
            timeParts.push(transport.date);
        }
        if (transport.departTime && transport.arriveTime) {
            timeParts.push(`${transport.departTime}～${transport.arriveTime}`);
        } else if (transport.departTime) {
            timeParts.push(transport.departTime);
        } else if (transport.arriveTime) {
            timeParts.push(`～${transport.arriveTime}`);
        }

        if (timeParts.length > 0) {
            parts.push(timeParts.join(' '));
        }

        return parts.filter(p => p && p.trim()).join(' ');
    };

    // 获取交通图标类名
    const getTransportIcon = transportType => {
        switch (transportType) {
            case '飞机':
                return 'bi-airplane';
            case '火车':
                return 'bi-train-front';
            case '高铁':
                return 'bi-lightning-charge';
            default:
                return 'bi-airplane';
        }
    };

    return (
        <Modal title={titleText} open={open} onCancel={onCancel} footer={null} width={520} className="transport-change-history-modal" centered>
            <div className="modal-content">
                {/* 嘉宾信息 */}
                {guestInfo && (
                    <div className="guest-info-section">
                        <div className="guest-name-row">
                            <span className="name-text">姓名：{guestInfo.name || '–'}</span>
                            {(guestInfo.gender === 0 || guestInfo.gender === 1) && <i className={`bi bi-person-fill gender-icon ${guestInfo.gender === 0 ? 'female' : 'male'}`}></i>}
                        </div>
                        <div className="guest-details">
                            <div className="detail-line">
                                <span className="label">级别：</span>
                                <span className="value line-level">{guestInfo.levelLabel || '–'}</span>
                            </div>
                            <div className="detail-line">
                                <span className="label">单位：</span>
                                <span className="value">
                                    <WorkExperiences workExperiences={guestInfo.workExperiences} layout="inline" showSerialNumber={false} emptyText="–" />
                                </span>
                            </div>
                        </div>
                    </div>
                )}

                {/* 变更记录列表 */}
                <div className="change-records-list">
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '40px 0' }}>
                            <Spin size="large" />
                            <div style={{ marginTop: 16, color: '#666' }}>正在加载变更记录...</div>
                        </div>
                    ) : changeRecords && changeRecords.length > 0 ? (
                        changeRecords.map((record, recordIndex) => (
                            <div key={recordIndex} className="change-record-item">
                                <div className="changer">
                                    <span className="changer-value">{record.operator || '-'}</span>
                                </div>
                                <div className="change-time-row">
                                    <span className="change-time">{record.changeTime || '-'}</span>
                                </div>

                                {/* 当前交通信息 */}
                                <div className="transport-box">
                                    <div className="transport-list">
                                        {record.newTransports && record.newTransports.length > 0 ? (
                                            record.newTransports.map((transport, index) => (
                                                <div key={index} className="transport-row">
                                                    <i className={`bi ${getTransportIcon(transport.type)} transport-icon`}></i>
                                                    <span className="transport-text">
                                                        {formatTransport(transport)}
                                                        {transport.ticketStatus && <span className={`ticket-status ${transport.ticketStatus === '已出票' ? 'issued' : 'not-issued'}`}>{transport.ticketStatus}</span>}
                                                    </span>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="transport-empty">无</div>
                                        )}
                                    </div>
                                </div>

                                {/* 变更理由 */}
                                {record.changeReason && <div className="change-reason">变更理由：{record.changeReason}</div>}
                            </div>
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', padding: '40px 0', color: '#888' }}>暂无变更记录</div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default TransportChangeHistoryModal;
